import React from "react";
import apiEndPoints from "../componets/json/apiEndPoints.json"
class _auth extends React.Component {

state = {
    auth: 0
}

componentDidMount() {
    if (this.props.user?.userId && this.state.auth === 0) this.auth();
}

auth = async () => {
    const _res = await this.props._api({
        ...this.props,
        method: "post",
        data: {
            guid: this.props.user?.userId,
            type: this.props.user?.type
        },
        endpoint: apiEndPoints.britex.profile.auth,
        param: "",
    });
    if (_res.status === 401) this.props.setLogOut();
    if (_res.status === 200) this.setState({auth: 1});
}

render() {
    return (<></>)
}
}

export default _auth